module.exports = __webpack_public_path__ + "static/media/Жуков Матвей Владиславович Лучшее, что есть у человека, - это собака Кировская обл-3.png";